import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm, ValidatorFn, EmailValidator, Validators } from '@angular/forms';
import { LoadJsService } from '../../load-js/load-js.service';
import { URLSearchParams } from '@angular/http';
import swal from 'sweetalert/dist/sweetalert.min.js';


@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./playbox.component.css']
})
export class InformationComponent implements OnInit {
  @ViewChild('closeBtn', { static: false }) closeBtn: ElementRef;

  textSearch = new FormControl('');
  
  msearch : string;
  customercategory:string;
  limit = 10;

  //pagination
  paging_link : any = [];
  paging : any = {};
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  //end pagination

  formSet = this.fb.group({
    customercategoryid: [''],
    title: [''],
    description: [''],
    url: [''],
    qrcodeimg: [''],
    showntype: [''],
  })

  listinfo:any = [];
  infodetail:any = [];
  listcustcategory:any = [];
  alert_act: any = [];
  showntypex: any = [];
  itemset: any = {};

  table_load = true

  message : string
  confirmation = false

  statusx = false
  slidevalue= false

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJs: LoadJsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadStart()
  }
  
  loadStart() {
    
    this.route.queryParams
      .subscribe(params => {

        //this.order = params.order;
        //console.log(this.order); // popular

        if ((params.search != '' || params.customercategory != '' ) && params.search != undefined ){
          // console.log('search');
          // console.log(params.search);
          this.msearch = params.search 
          this.customercategory = params.customercategory;
          this.querySearch = true
        

          this.currentParams = params;
          this.queryParams = '?'+this.queryStr(params)
          this.loadListinfo(this.queryParams)
        
        }else{
          this.querySearch = false;
          this.currentParams = params

          this.queryParams = '?'+this.queryStr(params)
          this.loadListinfo(this.queryParams)
        }
      });

      this.clearForm()
      this.loadcustcategory()
      this.msearch = undefined
      this.customercategory = undefined
    
  }
  
  refreshPage() {
    this.ngOnInit()
  }

  search()
  {
    if ( this.msearch == undefined){
      this.msearch = ''
    }

    this.querySearch = true;
    //this.searchQueryParams = this.queryParams+'&search='+this.msearch+'&customercategory='+this.customercategory;
    if ( this.customercategory == undefined ){
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch
    }else{
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch+'&customercategory='+this.customercategory
    }
    
    if ( this.limit != undefined ){
      this.searchQueryParams += '&limit='+this.limit
    }

    this.loadListinfo(this.searchQueryParams)
  }

  queryStr(options: any){
    let params = new URLSearchParams()
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString()
  }

  queryStrSearch()
  {
    if ( this.msearch ){
      return '&search='+this.msearch
    }else{
      return ''
    }
  }

  clearForm() {
    this.formSet.reset()
    this.formSet.get('customercategoryid').setValue(undefined)
    this.showntypex = ""
    this.statusx = false
    this.slidevalue = false
  }

  check1(){
    this.statusx = !this.statusx
    if (this.statusx == false){
      this.formSet.get('showntype').setValue(2)
      this.showntypex = "Hidden"
    }else{
      this.formSet.get('showntype').setValue(1)
      this.showntypex = "Shown"
    }
  }

  onActionClick(act:any, item: any) {
    this.alert_act = act

    if(this.alert_act == 'add'){
      this.clearForm()
    }
    if(this.alert_act == 'view'){
      this.itemset = item
      this.loadinfodetail(item.id)
    }
  }

  onConfirm(){
    swal({
      title: "Yakin?",
      icon: "info", 
      buttons: ["Tidak", "IYALAH!!!"],
    }).then((confirm) => {
      if (confirm) {
        swal(this.formSet.get('title').value +" is successfully saved.", 
        {
          icon: "sucess", 
        });
        this.ngOnInit()
      } else {
        swal("Huffff");
      }
    });
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }
  alertsx(message:any){
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(()=>{
      this.closeModal()
      this.ngOnInit()
    }, 1000);
  }
  alertfx(message:any){
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
    
  }

  loadListinfo(params: any) {
    this.table_load = true

    return this.partnerService.Getlistinfo(params).subscribe((output: any) => {
    console.log(output);
      this.listinfo = output.data;

      this.table_load = false

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      this.first_index = ((self-1)*this.meta['perPage'])+1;

    })
  }

  loadinfodetail(id:any){
    this.partnerService.Getinfodetail(id).subscribe((output: any) => { 
      this.infodetail = output.data

      this.formSet.get('customercategoryid').setValue(this.infodetail.customercategoryid)
      this.formSet.get('title').setValue(this.infodetail.title)
      this.formSet.get('description').setValue(this.infodetail.description)
      this.formSet.get('showntype').setValue(this.infodetail.showntype)
      this.formSet.get('url').setValue(this.infodetail.url)

      if(this.formSet.get('showntype').value == 1){
        this.statusx = true
        this.slidevalue = true
        this.showntypex = "Shown"
      }else{
        this.statusx = false
        this.slidevalue = false
        this.showntypex = "Hidden"
    }
    }); 
  }

  loadcustcategory() {
    this.partnerService.Getcustcategory().subscribe((output: any) => { 
      this.listcustcategory = output.data
    });  
  }

  submitAdd() {
    console.log(this.formSet.value)
    
    this.partnerService.Addinfo(this.formSet.value)
      .subscribe((output: any) => { 
        if (output.status == true) {

          this.message = output.message
          this.alertsx(this.message)

        } else {

          this.message = output.message
          this.alertfx(this.message)

        }
    })
  }
  submitSet() {
    let id = this.itemset.id
    console.log(id, this.formSet.value)
    
    this.partnerService.Setinfo(id, this.formSet.value)
      .subscribe((output: any) => { 
        if (output.status == true) {

          this.message = output.message
          this.alertsx(this.message)

        } else {

          this.message = output.message
          this.alertfx(this.message)

        }
    })
  }
  submitDelete() {
    let id = this.itemset.id

    swal({
      title: "Are you sure?",
      text: '"'+this.itemset.title+'" Akan dihapus',
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        console.log(id,this.itemset)
        this.partnerService.Deleteinfo(id)
          .subscribe((output: any) => { 
            if (output.status == true) {

              this.message = output.message
              this.alertsx(this.message)

            } else {

              this.message = output.message
              this.alertfx(this.message)

            }
        })
        
      } 
      // else {
      //   swal('"'+this.itemset.title+'" Batal dihapus');
      // }
    });
    
  }

}
